<template>
    <div class="grupo-form">
        <template>
            <div class="text-xs-center">
                <v-dialog v-model="showForm" width="500">
                    <v-card>
                        <v-toolbar card prominent color="primary" dark>
                            <v-toolbar-title class="body-2">{{ this.formTitle }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="cancelForm()">
                                <v-icon medium>fa-close</v-icon>
                            </v-btn>
                        </v-toolbar>

                        <v-flex>
                            <div slot="widget-content">
                                <v-alert
                                    v-model="showErrorDataLoadedAlert"
                                    type="error"
                                    dismissible
                                    transition="scale-transition"
                                    dark
                                >
                                    No se han podido cargar todos los datos necesarios para este formulario, intente
                                    cargar el formulario nuevamente.
                                </v-alert>
                            </div>
                        </v-flex>

                        <v-card-text>
                            <v-form ref="seccionForm" v-model="validGrupo">
                                <v-container fluid grid-list-xl>
                                    <v-layout align-center wrap>
                                        <v-flex xs12 sm12>
                                            <v-text-field
                                                v-model="grupoItem.letra"
                                                label="Grupo"
                                                :counter="255"
                                                :rules="letraRules"
                                                :error-messages="letraErrors"
                                                @blur="letraErrors = []"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm12>
                                            <v-autocomplete
                                                v-model="grupoItem.empleado_id"
                                                label="Profesor"
                                                :rules="empleado_idRules"
                                                :error-messages="empleado_idErrors"
                                                @change="empleado_idErrors = []"
                                                :items="EMPLEADOS"
                                                item-text="nombre"
                                                item-value="id"
                                                :filter="customFilter"
                                                hide-no-data
                                                hide-selected
                                            >
                                                <template v-slot:item="data">
                                                    <v-list-tile-content>
                                                        <v-list-tile-title
                                                            v-html="
                                                                data.item.nombre +
                                                                    ' ' +
                                                                    data.item.apellido_paterno +
                                                                    ' ' +
                                                                    data.item.apellido_materno
                                                            "
                                                        >
                                                        </v-list-tile-title>
                                                    </v-list-tile-content>
                                                </template>
                                                <template v-slot:selection="data">
                                                    {{
                                                        data.item.nombre +
                                                            " " +
                                                            data.item.apellido_paterno +
                                                            " " +
                                                            data.item.apellido_materno
                                                    }}
                                                </template>
                                            </v-autocomplete>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red" flat @click="cancelForm()" :disabled="loading">Cancelar</v-btn>
                            <v-btn
                                color="success"
                                flat
                                @click="saveForm()"
                                :disabled="disableSaveButton"
                                :loading="loading"
                                >Guardar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>
    </div>
</template>

<script>
/* eslint-disable */
    import { mapGetters } from "vuex"

    export default {
        props: {
            formTitle: String,
            initialItem: Object,
            gradoId: null
        },
        data () {
            return {
                loading: false,
                validGrupo: false,
                grupoItem: {
                    letra: '',
                    empleado_id: '',
                },
                letraRules: [
                    v => !!v || 'Debe proporcionar el grupo',
                    v => v.length <= 255 || 'El nombre solo puede contener 255 caracteres',
                ],
                letraErrors: [],
                empleado_idRules: [
                    v => !!v || 'Debe proporcionar el profesor'
                ],
                empleado_idErrors: [],

                //saber si se cargaron todos los datos necesarios para el formulario
                showErrorDataLoadedAlert: false
            }
        },
        computed: {
            ...mapGetters(['EMPLEADOS']),

            isNewRecord() {
                return this.initialItem === null
            },

            showForm: {
                get: function() {
                    return true
                },
                set: function () {
                    return this.cancelForm()
                }
            },

            disableSaveButton() {
                return this.loading || (!this.validGrupo)
            }
        },

        methods:{
            saveForm() {
                this.loading = true
                this.$refs.seccionForm.validate()
                if (this.validGrupo) {
                    var grupo = {
                        grado_id: this.gradoId,
                        letra: this.grupoItem.letra,
                        empleado_id: this.grupoItem.empleado_id,
                    }

                    if (!this.isNewRecord) {
                        grupo.id = this.initialItem.id
                    }

                    this.$store.dispatch(this.isNewRecord ? "ADD_GRUPO" : "UPDATE_GRUPO", grupo).then(
                        result => {
                            if (!result) {//no hay coneccion con el servidor
                                this.loading = false
                            }
                            if (result === null || result.status === 404 || result.status === 500) {
                                //cerrar el formulario si se inserto o actualizo bien (null) o cuando el elemento no existe
                                this.$emit("formCanceled")
                            } else {
                                // El backend devolvió error de validación, pasando los errores a los campos correspondientes
                                let { data, status } = result
                                if (status === 422) {
                                    data.forEach(error => {
                                        if (error.field === "letra") {
                                            this.letraErrors.push(error.message)
                                        }
                                        if (error.field === "empleado_id") {
                                            this.empleado_idErrors.push(error.message)
                                        }
                                    })
                                }
                            }
                            this.loading = false
                        }
                    )
                } else {
                    this.loading = false
                }
            },

            cancelForm() {
                this.$emit("formCanceled")
            },

			customFilter (item, queryText, itemText) {
				const textNombre = item.nombre.toLowerCase()
				const textApellidoPaterno = item.apellido_paterno.toLowerCase()
				const textApellidoMaterno = item.apellido_materno.toLowerCase()
				const searchText = queryText.toLowerCase()

				return textNombre.indexOf(searchText) > -1 ||
					textApellidoPaterno.indexOf(searchText) > -1 ||
					textApellidoMaterno.indexOf(searchText) > -1
			},
        },

        created() {
            this.$store.dispatch("LOAD_ALL_EMPLEADOS").then( data => {
                if (!data) {
                    this.showErrorDataLoadedAlert = true
                }
            })

            if (this.initialItem !== null) {
                // Cargando información del elemento a actualizar
                this.grupoItem.letra = this.initialItem.letra
                this.grupoItem.empleado_id = this.initialItem.empleado_id
            }
        },
    };
</script>
